/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function RewindCircle(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M24,128A104,104,0,1,0,128,24,104.11791,104.11791,0,0,0,24,128Zm44,0a7.99968,7.99968,0,0,1,3.41211-6.55371l40-28A8.00015,8.00015,0,0,1,124,100v28a7.99968,7.99968,0,0,1,3.41211-6.55371l40-28A8.00015,8.00015,0,0,1,180,100v56a8,8,0,0,1-12.58789,6.55371l-40-28A7.99968,7.99968,0,0,1,124,128v28a8,8,0,0,1-12.58789,6.55371l-40-28A7.99968,7.99968,0,0,1,68,128Z" />
    </Svg>
  );
}

export default RewindCircle;
